export const maxPositionLimit = 50;
